import { ShareNetwork, DotsThreeOutline, ShieldCheck } from "@phosphor-icons/react";

const STEPS = [
  {
    icon: ShareNetwork,
    title: "Click Share",
    desc: "In YouTube (or any video app), tap the Share button under the video you want to verify.",
  },
  {
    icon: DotsThreeOutline,
    title: "More Options",
    desc: "Scroll through the share sheet to find the full list of apps installed on your phone.",
  },
  {
    icon: ShieldCheck,
    title: "Select TrueStream",
    desc: "Pick TrueStream. We\u2019ll pull the claims and hand you back a verdict backed by real sources.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="pipeline"
      data-testid="how-it-works"
      className="max-w-[1600px] mx-auto w-full px-6 md:px-12 pb-16 relative z-10"
    >
      <div className="font-mono-plex text-[10px] font-semibold text-zinc-500 mb-3">
        HOW IT WORKS · THREE TAPS
      </div>
      <h2 className="font-display text-3xl md:text-5xl leading-tight tracking-tight text-zinc-950 mb-8 max-w-2xl">
        Fact-check any video from your phone in three taps.
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div
              key={s.title}
              data-testid={`how-step-${i + 1}`}
              className="border-2 border-black bg-white p-6 shadow-[6px_6px_0px_rgba(0,0,0,1)]"
            >
              <div className="font-mono-plex text-[10px] font-semibold text-emerald-700 mb-4">
                STEP {String(i + 1).padStart(2, "0")}
              </div>
              <Icon weight="duotone" className="w-10 h-10 text-zinc-950 mb-3" />
              <h3 className="font-display text-2xl text-zinc-950 mb-2">{s.title}</h3>
              <p className="text-[14px] text-zinc-700 leading-relaxed">{s.desc}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
